import ControllerBase from '../../../../global/js/ControllerBase';

interface ComponentRefs {
	scrollLeft: 'scrollLeft';
	scrollRight: 'scrollRight';
	scrollable: 'scrollable';
}
export default class ControllerTeaserGrid extends ControllerBase<ComponentRefs> {
	private readonly scrollLeftButton: HTMLSpanElement;
	private readonly scrollRightButton: HTMLSpanElement;
	private readonly scrollableWrapper: HTMLElement;
	private readonly gridElements;
	private minHeight: number = 0;
	private sliderElements;
	private offsetArray: any[] = [];

	constructor(element: HTMLElement) {
		super(element);
		this.scrollLeftButton = this.$references.scrollLeft as HTMLSpanElement;
		this.scrollRightButton = this.$references.scrollRight as HTMLSpanElement;
		this.gridElements = this.$references.scrollable as HTMLSpanElement;
		this.scrollableWrapper = this.$element.querySelector('.o-grid-container') as HTMLElement;
		this.sliderElements = this.gridElements.childNodes as NodeListOf<Element>;

		this.scrollLeftButton && this.scrollLeftButton.addEventListener('click', (e) => this.handleArrowClick(e, 'left'));
		this.scrollRightButton && this.scrollRightButton.addEventListener('click', (e) => this.handleArrowClick(e, 'right'));
		this.scrollableWrapper && this.scrollableWrapper.addEventListener('scroll', (e) => this.handleScroll(e));

		this.readMoreEvents();
	}

	private detectDeviceAndOffset(): void {
		const isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
		const isPortrait = (window.innerHeight > window.innerWidth);

		this.sliderElements.forEach(item => {
			setTimeout(() => {

				const isPhonePortrait = isTouch && isPortrait && window.innerWidth < 768;
				const isPhoneLandscape = isTouch && !isPortrait && window.innerWidth < 960;

				const isTabletPortrait = isTouch && isPortrait && (window.innerWidth >= 768 && window.innerWidth < 1024);
				const isTabletLandscape = isTouch && !isPortrait && (window.innerWidth >= 960 && window.innerWidth < 1400);

				const isIPadProPortrait = isTouch && isPortrait && (window.innerWidth >= 1024);

				const offset = isPhonePortrait ? item.offsetLeft + 1 : (isPhoneLandscape || isTabletPortrait) ? item?.offsetLeft : (isTabletLandscape || isIPadProPortrait) ? item?.offsetLeft - 35 : item?.offsetLeft - 184;

				this.offsetArray.push(offset)
			}, 50);
		})
	}

	/**
	 * Toggle Left Arrow
	 */
	private toggleLeftArrow(state: string): void {
		if (state === "enabled") {
			this.scrollLeftButton.removeAttribute('disabled');
			this.scrollLeftButton.style.pointerEvents = 'auto';
		}
		else {
			this.scrollLeftButton.setAttribute('disabled', '');
			this.scrollLeftButton.style.pointerEvents = 'none';
		}
	}

	/**
	 * Toggle Right Arrow
	 */
	private toggleRightArrow(state: string): void {
		if (state === "enabled") {
			this.scrollRightButton.removeAttribute('disabled');
			this.scrollRightButton.style.pointerEvents = 'auto';
		}
		else {
			this.scrollRightButton.setAttribute('disabled', '');
			this.scrollRightButton.style.pointerEvents = 'none';
		}
	}

	/**
	 * Toggle Arrows
	 */
	private toggleArrows(): void {
		if (this.scrollableWrapper.scrollLeft > 0) this.toggleLeftArrow('enabled');
		else this.toggleLeftArrow('disabled')

		const horizontalScrollReachedMax = Math.abs(this.scrollableWrapper.scrollLeft) === this.scrollableWrapper.scrollWidth - this.scrollableWrapper.clientWidth;
		if (horizontalScrollReachedMax) this.toggleRightArrow('disabled')
		else this.toggleRightArrow('enabled')
	}

	/**
	 * If user drags gallery on mobile, set the initial index and scrollLeft values relative to the scrollWrapper
	 */
	private handleScroll(e: any): void {
		setTimeout(() => {
			this.detectDeviceAndOffset();
			this.toggleArrows();
		}, 50);
	}

	/**
	 * Depending the scroll position change the class to disable the arrow
	 */
	private handleArrowClick(e: MouseEvent | PointerEvent, direction: string): void {
		e.preventDefault();

		this.detectDeviceAndOffset();

		const wrapperScrollLeft = this.scrollableWrapper.scrollLeft;

		setTimeout(() => {
			const closest = this.offsetArray.reduce(function (prev, curr) {
				return (Math.abs(curr - wrapperScrollLeft) < Math.abs(prev - wrapperScrollLeft) ? curr : prev);
			});

			const indexOfClosest = this.offsetArray.indexOf(closest)
			const differenceToClosest = closest - wrapperScrollLeft;
			const indexToScrollTo = direction === "right" ? (differenceToClosest > 0 ? indexOfClosest : indexOfClosest + 1) : (differenceToClosest >= 0 ? indexOfClosest - 1 : indexOfClosest);
			const newPosition = direction === "right" ? (wrapperScrollLeft < this.offsetArray[1] ? this.offsetArray[1] : this.offsetArray[indexToScrollTo]) : indexToScrollTo === 0 ? 0 : this.offsetArray[indexToScrollTo];

			this.scrollableWrapper.scrollTo(newPosition, 0);

			setTimeout(() => this.toggleArrows(), 300);
		}, 50)
	}

	private readMoreEvents(): void {
		const parentElement = this.$element.querySelectorAll('.js-read-more');
		const readMoreItems = this.$element.querySelectorAll('.js-read-more-child');

		parentElement.forEach((parent) => {
			const elements = parent.querySelectorAll('.readMore-element .js-read-more-link');
			elements.forEach((element) => {
				element?.addEventListener('click', (e) => {
					element.parentElement?.classList.add('open');
					this.setHeight(readMoreItems);
				});
			});
		});
	}

	private setHeight(items) {
		items.forEach((child) => {
			const currentHeight = child.clientHeight;
			if (currentHeight > this.minHeight) {
				this.minHeight = currentHeight;
			}
		});

		items.forEach((ch: HTMLDivElement) => {
			ch.style.minHeight = this.minHeight + 'px';
		});
	}
}
